module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notifications":"Notifications","dismiss_all":"Dismiss All","unknown":"unknown"},"es":{"notifications":"Notificaciones","dismiss_all":"Descartar todo","unknown":"desconocido"}}')
  delete Component.options._Ctor
}
